module.exports = {"id":"209827","name":"Júnior Fernandes","rating":"74","photo":"./data/images/photos/0/209827.png","club":{"name":"Aytemiz Alanyaspor","logo":"./data/images/clubs/AytemizAlanyaspor.png"},"positions":["MG","MD","ATT","BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JuniorFernandes0.json
// module id = 2257
// module chunks = 0